import { useLocation, Outlet } from 'react-router-dom';
// @mui
import { Box, Link, Container, Typography, Stack } from '@mui/material';
// components
import Logo from '../../components/Logo';
// components
import { useSelector } from '../../redux/store';
//
import MainFooter from './MainFooter';
// import MainHeader from './MainHeader';

// ----------------------------------------------------------------------

export default function MainLayout() {
  const { currentTenant } = useSelector((state) => state.tenant);

  const { pathname } = useLocation();

  const isHome = pathname === '/';

  return (
    <Stack sx={{ minHeight: 1 }}>
      {/* <MainHeader /> */}

      <Outlet />

      <Box sx={{ flexGrow: 1 }} />

      {!isHome ? (
        <MainFooter />
      ) : (
        <Box
          sx={{
            py: 5,
            textAlign: 'center',
            position: 'relative',
            bgcolor: 'background.default',
          }}
        >
          {!currentTenant && (
            <Container>
              <Logo sx={{ mb: 1, mx: 'auto' }} />
              <Typography variant="caption" component="p">
                © All rights reserved
                <br /> made by &nbsp;
                <Link href="https://uptin.vn/">Uptin.vn</Link>
              </Typography>
            </Container>
          )}
        </Box>
      )}
    </Stack>
  );
}
